/**
 * PORT-4
 * БАГ: Сделать закрытие картинки по щелчку мимо нее
 * Блок: Контент документации
 * Раздел: Документация
 * При нажатии на рисунок он открывается в исходном размере. Было бы удобно,
 * если бы он закрывался по щелчку мимо рисунка, или была бы кнопка закрытия
 * Просмотр изображений
 **/
import "./fancybox.css"
$("figure").each(function () {
    const src=$(this).find("img").attr("src")
    const caption = $(this).find("figcaption").text().trim();
    const caption_html = $(this).find("figcaption").text();
    // console.log($(this).parent().html())
    $(this).replaceWith(`
<figure style="text-align: left">
    <a href="${src}" data-fancybox="gallery" data-caption="${caption}">
        <img src="${src}">
    </a>
    ${caption_html}
</figure>
`)

});

$(document).ready(function () {
    Fancybox.bind('[data-fancybox="gallery"]', {});
});


$('p>a>img').click(function(e, d) {
     return false;
})
